import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
interface ShareDialogProps {
  showDeleteConfirmDialog: boolean;
  setShowDeleteConfirmDialog: React.Dispatch<React.SetStateAction<boolean>>;
  handleConfirm: () => void;
}
const QuestionDeleteConfirmDialog: React.FC<ShareDialogProps> = ({
  showDeleteConfirmDialog,
  setShowDeleteConfirmDialog,
  handleConfirm,
}: ShareDialogProps) => {
  return (
    <AlertDialog
      open={showDeleteConfirmDialog}
      onOpenChange={setShowDeleteConfirmDialog}
    >
      <AlertDialogContent
        className="border! border-[rgba(0,0,0,0.08)]! p-[25px]! max-w-[536px]! gap-4"
        style={{
          borderRadius: '20px',
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
          overflow: 'hidden',
        }}
      >
        <AlertDialogHeader className="space-y-2!">
          <AlertDialogTitle
            className="font-semibold! tracking-[-0.4395px]! text-black"
            style={{
              fontFamily: 'Inter, sans-serif',
              lineHeight: '28px',
              fontSize: '18px',
              fontWeight: 600,
            }}
          >
            Are you sure you want to delete this question?
          </AlertDialogTitle>
          <AlertDialogDescription
            className="tracking-[-0.1504px]!"
            style={{
              color: '#666666',
              fontFamily: 'Inter, sans-serif',
              lineHeight: '20px',
              fontSize: '14px',
              fontWeight: 400,
            }}
          >
            This will permanently delete the question.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="gap-2! flex-row! justify-end!">
          <AlertDialogAction
            onClick={handleConfirm}
            className="rounded-full! h-9! px-[17px]! border! border-[rgba(0,0,0,0.08)]! text-[14px]! font-medium! tracking-[-0.1504px]! opacity-100!"
            style={{
              fontFamily: 'Inter, sans-serif',
              backgroundColor: '#FFFFFF',
              color: '#000000',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#000000';
              e.currentTarget.style.color = '#FFFFFF';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FFFFFF';
              e.currentTarget.style.color = '#000000';
            }}
          >
            Yes, delete it
          </AlertDialogAction>
          <AlertDialogCancel
            className="rounded-full! h-9! px-4! text-[14px]! font-medium! tracking-[-0.1504px]! opacity-100!"
            style={{
              fontFamily: 'Inter, sans-serif',
              backgroundColor: '#FFFFFF',
              color: '#000000',
              border: '1px solid rgba(0, 0, 0, 0.08)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#000000';
              e.currentTarget.style.color = '#FFFFFF';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#FFFFFF';
              e.currentTarget.style.color = '#000000';
            }}
          >
            Cancel
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default QuestionDeleteConfirmDialog;
